import styled from 'styled-components';
import BaseButton from '../../../common/BaseButton';
import FilledButton from '../../../common/FilledButton';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

export const DiscussBtn = styled(FilledButton)`
  margin-top: 16px;
  width: 328px;
  height: 63px;

  ${mediaWidth.m} {
    margin: 0;
    width: 324px;
    height: 63px;
  }

  ${mediaWidth.l} {
    width: 321px;
    height: 63px;
  }

  ${mediaWidth.xl} {
    width: 355px;
    height: 71px;
  }
`;

export const RepeatBtn = styled(BaseButton)`
  margin-top: 16px;
  width: 328px;
  height: 63px;

  border: 2px solid #000000;

  ${mediaWidth.m} {
    margin: 0;
    width: 324px;
    height: 63px;
  }

  ${mediaWidth.l} {
    width: 321px;
    height: 63px;
  }

  ${mediaWidth.xl} {
    width: 355px;
    height: 71px;
  }
`;
